<div data-test="container-cards-grid" class="cards-grid" [style.--grid-cols]="desktopColumns" [style.--grid-min-card.px]="minCardWidth">
    <ng-content></ng-content>
</div>
